import React from 'react';
import { navigate } from 'gatsby';
import ReactModal from 'react-modal';
import Icons from '../components/layouts/Icons';

export default function Search({ isOpen, clickHandler }) {
  const [searchValue, setSearchValue] = React.useState('');
  const handleChange = ({ target }) => {
    setSearchValue(target.value);
  };

  const handleSearchClick = (event) => {
    event.preventDefault();
    navigate(`/search?${searchValue}`);
  };
  return (
    <ReactModal
      isOpen={isOpen}
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      shouldFocusAfterRender
      onRequestClose={clickHandler}
      className="text-white py-16 px-12"
      overlayClassName="fixed top-0 left-0 z-[100] inset-0 bg-bg-3 flex flex-col justify-center
      items-center outline-none border-[tranparent] border-0 appearance-none">
      <button
        type="button"
        onClick={clickHandler}
        className="absolute top-[100px] right-[150px] w-[40px] h-[40px] bg-white flex
        justify-center items-center">
        <Icons icon="close" className="w-[20px] h-[20px]" />
      </button>
      <div className="w-[800px] h-[40px] relative">
        <input
          type="text"
          placeholder="Search"
          autoFocus
          onChange={handleChange}
          onKeyDown={(event) => (event.keyCode === 13 ? handleSearchClick(event) : null)}
          data-results-page="/search"
          className="outline-none text-base placeholder:uppercase font-roboto-regular text-white
          border-b-2 border-b-slate-200 pr-8 pl-4 pt-2 w-full bg-bg-3"
        />
        <button className="btn-search" type="submit" onClick={handleSearchClick}>
          <Icons
            icon="home-search-icon"
            className="fill-white absolute right-[15px] top-0 w-[30px]
        h-[30px]"
          />
        </button>
      </div>
    </ReactModal>
  );
}
